import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	InputSignal,
	output,
	OutputEmitterRef,
	Signal,
	signal,
	WritableSignal,
} from '@angular/core'
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import {
	TuiDataListComponent,
	TuiDropdown,
	TuiIcon,
	TuiNumberFormat,
	TuiTextfield,
	TuiTextfieldComponent,
} from '@taiga-ui/core'
import { TuiInputNumber } from '@taiga-ui/kit'
import { QuantityPipe } from '@shared/pipes/quantity.pipe'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { ImageComponent } from '@shared/components/common/image/image.component'
import { MaxDecimalCount } from '@modules/stocks-module/general/constants/max-decimal-count'
import { QtyTypeInterface } from './interfaces/qty-type.interface'
import { QtyTypes } from './constants/qty-types'
import { QtyTypeEnum } from './enums/qty-type.enum'
import { InputNumberSignsDirective } from '@shared/directives/input-number-signs.directive'

@UseLocales({ ru, en })
@Component({
	selector: 'app-order-qty-input',
	templateUrl: './order-qty-input.component.html',
	styleUrl: './order-qty-input.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		ReactiveFormsModule,
		TranslatePipe,
		TuiTextfield,
		TuiTextfieldComponent,
		TuiDataListComponent,
		TuiDropdown,
		TuiInputNumber,
		TuiNumberFormat,
		TuiDataListComponent,
		TuiIcon,
		QuantityPipe,
		ImageComponent,
		InputNumberSignsDirective,
	],
})
export class OrderQtyInputComponent {
	protected readonly maxDecimalCount: number = MaxDecimalCount
	protected readonly infinity: number = Infinity
	protected readonly qtyTypes: QtyTypeInterface[] = QtyTypes
	protected readonly qtyTypeEnum: typeof QtyTypeEnum = QtyTypeEnum

	public control: InputSignal<AbstractControl | null> = input<AbstractControl | null>(null)
	public activeQtyType: InputSignal<QtyTypeInterface | null> = input<QtyTypeInterface | null>(null)
	public availableQty: InputSignal<number> = input<number>(0)
	public qty: InputSignal<number> = input<number>(0)
	public step: InputSignal<number> = input<number>(1)
	public isMaxDecimalCount: InputSignal<boolean> = input<boolean>(false)
	public visibleLabel: InputSignal<boolean> = input<boolean>(true)
	public visibleQtySelect: InputSignal<boolean> = input<boolean>(false)

	public qtyTypeChange: OutputEmitterRef<QtyTypeInterface> = output<QtyTypeInterface>()

	protected isOpenQtyTypes: WritableSignal<boolean> = signal<boolean>(false)

	protected formControl: Signal<FormControl> = computed<FormControl>((): FormControl => {
		return (this.control() ?? new FormControl()) as FormControl
	})

	protected setQtyType(qtyType: QtyTypeInterface): void {
		this.isOpenQtyTypes.set(false)
		this.qtyTypeChange.emit(qtyType)
	}
}
